import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccountCompletion } from '../interfaces/account-completion';

@Injectable({
  providedIn: 'root',
})
export class OnboardingAdapter {
  private http = inject(HttpClient);

  /**
   * Updates company details during onboarding phase 1.
   * @param {unknown} payload - Profile form values
   * @returns {Observable<unknown>}
   */
  updateCompanyDetails(payload: unknown): Observable<unknown> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/user/onboarding/company-details`,
      payload,
    );
  }

  /**
   * Updates user and company questionnaire details during onboarding phase 1.
   * @param {unknown} payload - Company form values
   * @returns {Observable<unknown>}
   */
  updateUserDetails(payload: unknown): Observable<unknown> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/user/onboarding/user-details`,
      payload,
    );
  }

  /**
   * Saves recruiting-team questionnaire answers during onboarding phase 1.
   * @param {unknown} payload - Team form values
   * @returns {Observable<unknown>}
   */
  updateTeamAccount(payload: unknown): Observable<unknown> {
    return this.http.post(
      `${environment.apiBaseUrl}/company/user/onboarding/questionnaire`,
      payload,
    );
  }

  /**
   * Loads dashboard account completion progress.
   * @returns {Observable<AccountCompletion>}
   */
  getAccountCompletion(): Observable<AccountCompletion> {
    return this.http.get<AccountCompletion>(
      `${environment.apiBaseUrl}/company/user/onboarding/account-completion`,
    );
  }

  /**
   * Skips remaining account completion steps on the dashboard.
   * @returns {Observable<AccountCompletion>}
   */
  skipAccountCompletion(): Observable<AccountCompletion> {
    return this.http.patch<AccountCompletion>(
      `${environment.apiBaseUrl}/company/user/onboarding/account-completion/skip`,
      {},
    );
  }

  /**
   * Marks the company onboarding flow as completed.
   * @returns {Observable<void>}
   */
  completeOnboarding(): Observable<void> {
    return this.http.patch<void>(
      `${environment.apiBaseUrl}/company/user/onboarding/complete`,
      {},
    );
  }
}
